const IDENT22 = Object.freeze([1, 0, 0, 1]);
const IDENT23 = Object.freeze([1, 0, 0, 1, 0, 0]);
const IDENT33 = Object.freeze([
  1,
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  1
]);
const IDENT44 = Object.freeze([
  1,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  1
]);
export {
  IDENT22,
  IDENT23,
  IDENT33,
  IDENT44
};
